import { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import axios from 'axios'
import { useIntl } from 'react-intl'
import { CircularProgress } from '@material-ui/core'
import { BEEWO_REDIRECT_URL, connectSocialProviderURL } from './constants'
import MessageAlert from 'app/components/MessageAlert'
import { SOCIAL_PROVIDER_KEY_TWITTER } from 'app/main/integrations/socialMediaIntegration/configs/socialMediaIntegrationConfig'

const IntegrationsBeewo = () => {
  const [isLoading, setIsLoading] = useState(false)
  const dispatch = useDispatch()

  const { formatMessage } = useIntl()

  const parseState = (stateString) => {
    try {
      return JSON.parse(stateString) || {}
    } catch (error) {
      return {}
    }
  }

  const extractDataFromURL = (urlSearch) => {
    const data = {}
    let secretKey = null

    if (urlSearch.has('state')) {
      const { providerKey = '', secretKey: stateSecretKey = null } = parseState(
        urlSearch.get('state'),
      )

      if (urlSearch.has('code')) {
        data.code = urlSearch.get('code') || ''
      }
      data.type = providerKey
      secretKey = stateSecretKey
    } else if (
      urlSearch.has('oauth_token') &&
      urlSearch.has('oauth_verifier') &&
      urlSearch.has('apiSecretKey')
    ) {
      data.type = SOCIAL_PROVIDER_KEY_TWITTER
      data.oauthToken = urlSearch.get('oauth_token') || ''
      data.oauthVerifier = urlSearch.get('oauth_verifier') || ''
      secretKey = urlSearch.get('apiSecretKey') || ''
    }

    return { data, secretKey }
  }

  const connectSocialProvider = useCallback(async ({ secretKey, data }) => {
    setIsLoading(true)
    try {
      const headers = {
        'x-secret-key': secretKey,
      }

      await axios.post(connectSocialProviderURL(), data, { headers })
      window.location.href = `${BEEWO_REDIRECT_URL}?providerKey=${encodeURIComponent(data.type)}`
    } catch (err) {
      dispatch(
        MessageAlert.showError({
          message: formatMessage({ id: 'wrong.msg' }),
        }),
      )
    } finally {
      setIsLoading(false)
    }
  }, [])

  useEffect(() => {
    const urlSearch = new URLSearchParams(window.location.search)
    const { data, token, secretKey } = extractDataFromURL(urlSearch)

    if (
      data.type &&
      secretKey &&
      (data.code || (data.oauthToken && data.oauthVerifier))
    ) {
      connectSocialProvider({ token, secretKey, data })
    } else {
      window.location.href = BEEWO_REDIRECT_URL
    }
  }, [])

  return (
    <>
      {isLoading && (
        <div className="flex justify-center items-center w-full h-full">
          <CircularProgress color="secondary" size={50} />
        </div>
      )}
    </>
  )
}

export default IntegrationsBeewo
